/**
 *
 * Asynchronously loads the component for NewOrder
 *
 */

import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import('./index' /* webpackChunkName: "NewOrder" */),
  loading: () => null
})
